import listActions from 'src/modules/descRegistro/list/descRegistroListActions';
import DescRegistroService from 'src/modules/descRegistro/descRegistroService';
import Errors from 'src/modules/shared/error/errors';
import { i18n } from 'src/i18n';
import { getHistory } from 'src/modules/history';
import Message from 'src/view/shared/message';

const prefix = 'DESCREGISTRO_DESTROY';

const descRegistroDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: descRegistroDestroyActions.DESTROY_STARTED,
      });

      await DescRegistroService.destroyAll([id]);

      dispatch({
        type: descRegistroDestroyActions.DESTROY_SUCCESS,
      });

      Message.success(
        i18n('entities.descRegistro.destroy.success'),
      );

      dispatch(listActions.doFetchCurrentFilter());

      getHistory().push('/desc-registro');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: descRegistroDestroyActions.DESTROY_ERROR,
      });
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: descRegistroDestroyActions.DESTROY_ALL_STARTED,
      });

      await DescRegistroService.destroyAll(ids);

      dispatch({
        type: descRegistroDestroyActions.DESTROY_ALL_SUCCESS,
      });

      if (listActions) {
        dispatch(listActions.doClearAllSelected());
        dispatch(listActions.doFetchCurrentFilter());
      }

      Message.success(
        i18n('entities.descRegistro.destroyAll.success'),
      );

      getHistory().push('/desc-registro');
    } catch (error) {
      Errors.handle(error);

      dispatch(listActions.doFetchCurrentFilter());

      dispatch({
        type: descRegistroDestroyActions.DESTROY_ALL_ERROR,
      });
    }
  },
};

export default descRegistroDestroyActions;
